import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex min-h-16 w-full resize-none rounded-md border border-gray-300 bg-[#f5f5f5] px-3 py-2 text-base text-[#2d2d2d] outline-none transition-[color,box-shadow] placeholder:text-gray-500 focus-visible:border-[#E91E8C] focus-visible:ring-2 focus-visible:ring-[#E91E8C]/30 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
